import React from 'react';
import toast from 'react-hot-toast';
import { downloadOperationsReportPdf, downloadOperationsSampleReportPdf } from '../../../services/api/implementation/impl';

const saveBlob = (blob, filename) => {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
};

/**
 * Download an operations report PDF generated by the backend.
 * type: 'today' | 'weekly' | 'monthly'. Pass the same projectId and reportRunDate
 * the page uses to load the report, so the PDF matches what is on screen.
 * downloadSamplePdf downloads the sample report instead and needs neither.
 */
const useOperationsReportPdf = (type) => {
    const [isDownloadingPdf, setIsDownloadingPdf] = React.useState(false);

    const run = React.useCallback(async (fetchPdf) => {
        setIsDownloadingPdf(true);
        try {
            const { blob, filename } = await fetchPdf();
            saveBlob(blob, filename);
        } catch (error) {
            const message = error?.response?.data?.message;
            toast.error(typeof message === 'string' && message ? message : 'Could not create the PDF. Please try again.');
        } finally {
            setIsDownloadingPdf(false);
        }
    }, []);

    const downloadPdf = React.useCallback(async (projectId, reportRunDate) => {
        if (!projectId || !reportRunDate) return;
        await run(() => downloadOperationsReportPdf(type, projectId, reportRunDate));
    }, [run, type]);

    const downloadSamplePdf = React.useCallback(
        () => run(() => downloadOperationsSampleReportPdf(type)),
        [run, type]
    );

    return { downloadPdf, downloadSamplePdf, isDownloadingPdf };
};

export default useOperationsReportPdf;
